import {GridColumnGroupingModel} from '@mui/x-data-grid-pro'

export const ProgramsGroupingModel = (programName: any, activeTab: any) => {
  const saeolGrouping: GridColumnGroupingModel = [
    // {
    //   groupId: '이름',
    //   headerAlign: 'center',
    //   description: '수용가에 관한 정보입니다.',
    //   children: [{field: 'address_road'}],
    // },
    {
      groupId: '전월검침정보',
      headerAlign: 'center',
      description: '전월 검침내역에 관한 정보입니다.',
      children: [{field: 'bef_check_code'}, {field: 'bef_check_value'}, {field: 'bef_used'}],
    },
    {
      groupId: '당월검침정보',
      headerAlign: 'center',
      description: '당월 검침내역에 관한 정보입니다.',
      children: [
        {field: 'now_check_info'},
        {field: 'file_path'},
        {field: 'check_value'},
        {field: 'now_check_code'},
        {field: 'now_used'},
      ],
    },
  ]

  const saeol1SubSeleteGrouping: GridColumnGroupingModel = [
    {
      groupId: '당월검침정보',
      headerAlign: 'center',
      description: '당월 검침내역에 관한 정보입니다.',
      children: [
        {field: 'now_check_info'},
        {field: 'file_path'},
        {field: 'check_value'},
        {field: 'now_check_code'},
      ],
    },
    {
      groupId: '전월검침정보',
      headerAlign: 'center',
      description: '전월 검침내역에 관한 정보입니다.',
      children: [
        {field: 'bef_check_code'},
        {field: 'bef_check_date'},
        {field: 'bef_check_info'},
        {field: 'bef_file_path'},
        {field: 'bef_check_value'},
        {field: 'bef_used'},
      ],
    },
  ]

  const saeol1Grouping: GridColumnGroupingModel = [
    {
      groupId: '당월검침정보',
      headerAlign: 'center',
      description: '당월 검침내역에 관한 정보입니다.',
      children: [
        {field: 'now_check_info'},
        {field: 'file_path'},
        {field: 'check_value'},
        {field: 'now_check_code'},
      ],
    },
  ]

  const wimsGrouping: GridColumnGroupingModel = [
    {
      groupId: '전월검침정보',
      headerAlign: 'center',
      description: '전월 검침내역에 관한 정보입니다.',
      children: [
        {field: 'bef_check_info'},
        {field: 'bef_check_code'},
        {field: 'bef_check_value'},
        {field: 'bef_used'},
      ],
    },
    {
      groupId: '당월검침정보',
      headerAlign: 'center',
      description: '당월 검침내역에 관한 정보입니다.',
      children: [
        {field: 'now_check_info'},
        {field: 'file_path'},
        {field: 'check_value'},
        {field: 'now_used'},
        {field: 'now_check_code'},
      ],
    },
  ]
  const bluewaterGrouping: GridColumnGroupingModel = [
    {
      groupId: '전월검침정보',
      headerAlign: 'center',
      description: '전월 검침내역에 관한 정보입니다.',
      children: [
        {field: 'bef_check_info'},
        {field: 'bef_check_code'},
        {field: 'bef_check_value'},
        {field: 'bef_used'},
      ],
    },
    {
      groupId: '당월검침정보',
      headerAlign: 'center',
      description: '당월 검침내역에 관한 정보입니다.',
      children: [
        {field: 'now_check_info'},
        {field: 'file_path'},
        {field: 'check_value'},
        {field: 'now_used'},
        {field: 'now_check_code'},
      ],
    },
  ]

  const crebizGrouping: GridColumnGroupingModel = [
    {
      groupId: '전월검침정보',
      headerAlign: 'center',
      description: '전월 검침내역에 관한 정보입니다.',
      children: [{field: 'bef_check_code'}, {field: 'bef_check_value'}, {field: 'bef_used'}],
    },
    {
      groupId: '당월검침정보',
      headerAlign: 'center',
      description: '당월 검침내역에 관한 정보입니다.',
      children: [
        {field: 'now_check_info'},
        {field: 'file_path'},
        {field: 'check_value'},
        {field: 'now_check_code'},
        {field: 'now_used'},
      ],
    },
  ]

  switch (programName) {
    case 'SAEOL1':
      switch (activeTab) {
        case '부관':
          return saeol1SubSeleteGrouping
        default:
          return saeol1Grouping
      }
    case 'SAEOL':
      return saeolGrouping
    case 'WIMS':
      return wimsGrouping
    case 'BLUEWATER':
      return bluewaterGrouping
    case 'CREBIZ':
      return crebizGrouping
    default:
      return []
  }
}
